import React from 'react';

import ActionsAddPasswordDocument from './ActionsAddPasswordDocument';

const ActionsAddPasswordDocx = (props) => (
  <ActionsAddPasswordDocument
    {...props}
    actionType="addpassworddocx"
    defaultTargetPath={'C:\\output\\{filename}_protected.docx'}
    documentType="DOCX"
    extension="docx"
    titleKey="workflow.add_password_docx_title"
    titleFallback="Add Password to DOCX"
  />
);

export default React.memo(ActionsAddPasswordDocx);
